import type { RootState } from '..';
import type { ContainerLayoutViewModel } from '../types';

export const getContainerLayoutViewModels = (state: RootState): Record<string, ContainerLayoutViewModel> =>
    state.layout.byContainerId;
